const translations = {
    addButton: '+ Add'
};

export default translations;
